<template>
  <div class="remove_table_shadow">
    <div class="form-row mt-3 mr-5" style="align-items: center">
        <div class="col-sm-12">
            <div v-if="this.active != 1">
            <button
                type="button"
                class="btn btn-sm btn-primary el-button--default"
                v-if="this.active < 3"
                @click="previous"
                style="float: right"
            >
                <span>Previous</span>
            </button>
            </div>
        </div>
    </div>
    <el-form v-if="active === 1">
        <app-table
            :id="tableId"
            :options="options"
            @action="getListAction"
        />
    </el-form>
    <el-form v-if="active === 2">
      <task-mytask-view :id="id" :active="{ active }" :remove="classRemove"></task-mytask-view>
    </el-form> 
  </div>
</template>

<script>
import CoreLibrary from "../../../../core/helpers/CoreLibrary";
import * as actions from "../../../Config/ApiUrl";
import { TableHelpers } from "../Demo/Tables/mixins/TableHelpers";
// import AppFunction from "../core/helpers/app/AppFunction";
import AppFunction from "../../../../core/helpers/app/AppFunction";
import { axiosGet, axiosPost } from "../../../Helpers/AxiosHelper.js";
import { Input } from "element-ui";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  data() {
    return {
      active: 1,
      id: 0,
      classRemove: true,
      packages: {},
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      input: {},
      options: {
        name: "AdvanceTable",
        url: actions.COMPLETED_TASKS,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
         columns: [
          {
            title: this.$t("task"),
            type: "custom-html",
            key: "title",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("assigned_to"),
            type: "component",
            key: "users",
            isVisible: true,
            className: "w-100",
            componentName: "group-of-users",
          },
          // {
          //     title: this.$t('assigned_to'),
          //     type: 'custom-html',
          //     key: 'assigned_to',
          //     modifier: (value) => {
          //         return `<span>${this.$t(value)}</span>`
          //     }
          // },
          {
            title: this.$t("start_date"),
            type: "custom-html",
            key: "start_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("due_date"),
            type: "custom-html",
            key: "due_date",
            modifier: (value) => {
              var result = '';
              let ClassName = "warning";

              const moment = require('moment');
              // Define your due date and current date
              const dueDate = moment(value+' 23:59:59'); // Replace with your due date
              const currentDate = moment(); // Current date and time

              // Calculate the difference in time
              const timeDiff = dueDate.diff(currentDate);
              if (timeDiff > 0) {
                const duration = moment.duration(timeDiff);
                if (duration.days() > 0) {
                  result = `${duration.days()} day${duration.days() > 1 ? 's' : ''} left`;
                  if(duration.days() > 30) {
                    ClassName = 'success';
                  }
                } else if (duration.hours() > 0) {
                  result = `${duration.hours()} hour${duration.hours() > 1 ? 's' : ''} left`;
                } else {
                  result = `${duration.minutes()} minute${duration.minutes() > 1 ? 's' : ''} left`;
                }
              } else {
                  result = 'The due date has passed.';
                  ClassName = 'danger';
              }
              // return `<span>${this.$t(result)}</span>`;
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                result
              )}</span>`;
            },
          },
          {
            title: this.$t("priority"),
            type: "custom-html",
            key: "priority",
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "low") ClassName = `success`;
              else if (value === "medium") ClassName = `warning`;
              else if (value === "high") ClassName = `danger`;
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "completed") ClassName = `success`;
              else if (value === "incomplete") ClassName = `warning`;

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
        ],
        filters: [
          // {
          //     "title": this.$t('date'),
          //     "type": "range-picker",
          //     "key": "date",
          //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
          // },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          // {
          //     "title": this.$t('status'),
          //     "type": "checkbox",
          //     "key": "status",
          //     "option": [
          //         {id: 'active', value: 'Active'},
          //         {id: 'inactive', value: 'Inactive'},
          //         {id: 'invited', value: 'Invited'},
          //     ],
          // },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "asc",
        actionType: "default",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  mounted() {
    // this.getPackages();
    var userinfo = this.$store.state.userCompanyProfile.dataProfile;
    var company_id = userinfo.company_id;
    var user_id = userinfo.id;
    if (company_id != null) {
      this.options.url = actions.COMPLETED_TASKS+'/' + company_id + '?user_id='+user_id;
    }
    setTimeout(() => {
      $( ".remove_table_shadow .h-100 .datatable .table-responsive " ).removeClass("shadow");
    }, 1000);
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("view")) {
          this.id = rowData.id;
          this.active = 2;
        // this.buyerCertificate(rowData.id);
      }
    },

    buyerCertificate(id) {
      this.input.id = id;
      axiosPost(actions.BUYER_CERTIFICATE_STORE, this.input)
        .then((res) => {
          this.$toastr.s(res.data);
          location.reload();
        })
        .catch((error) => {
          this.$toastr.s(error);
        });
    },
    previous() {
        this.active = 1;
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.PACKAGE_DISTROY}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosGet(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    // searchAndSelectFilterOptions() {
    //   this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
    //     let name = this.options.filters.find(
    //       (element) => element.title === this.$t("search_and_select")
    //     );

    //     name.option = response.data.map((name) => {
    //       return {
    //         id: name.name,
    //         value: name.name,
    //       };
    //     });
    //   });
    // },
    // getPackages() {
    //   axiosGet(actions.ADMIN_CERTIFICATE)
    //     .then((res) => {
    //       this.packages = res.data.data;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },
    btnSubmit(id) {
      location.replace("/admin/stripePay/" + id);
    },
  },
};
</script>
<style scoped>
.remove_table_shadow .h-100 .datatable .table-responsive {
  box-shadow: none !important;
}
</style>
